const courseSubQuery = `
    course(uuid: $uuid) {
        id
        uuid
        school_id
        start_time
        end_time
        title
        location {
            name
        }
    }
`
const eventSubQuery = `
    event(uuid: $uuid) {
        id
        uuid
        school_id
        start_time
        end_time
        title
        location {
            name
        }
    }
`
export const getAttendancePartial = `
    id
    status
    meets
    enter
    lock
    overrides {
        old_status
        user {
            first_name
            last_name
        }
    }
    coordinates {
        id
        attendance_id
        latitude
        longitude
    }
`
export const getAttendance = (type) => `
    query getAttendance($studentUuid: String!, $uuid: String!, $type: String!) {
        attendance(student_uuid: $studentUuid, uuid: $uuid, type: $type) {
            id
            status
            lock
            enter
            exit
            percentage
            finished
            created_at
            student_id
            attendable_id
            attendable_type
            location_id
            school_id
            school {
                id
                timezone
            }
            coordinates {
                latitude
                longitude
                low_power
                extra
                bluetooth
                created_at
            }
            overrides {
                old_status
                user {
                    first_name
                    last_name
                }
            }
            activity {
                event
                created_at
            }
        }
        ${type == 'course' ? courseSubQuery : eventSubQuery }
        student(uuid: $studentUuid) {
            id
            uuid
            first_name
            last_name
            email
        }
    }
`